"use client";

import { Button } from "@heroui/react";
import { IconArrowRight } from "@tabler/icons-react";
import { useRouter } from "next/navigation";

export default function CompareCta() {
  const router = useRouter();

  return (
    <section className="container mx-auto py-12 px-8">
      <div className="max-w-4xl mx-auto bg-default-50 rounded-2xl p-8 md:p-12 text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">
          See how SEO AI Pal compares to other tools
        </h2>

        <p className="text-lg mb-8">
          We've created a detailed comparison of SEO AI Pal vs traditional SEO
          tools. Learn why indie hackers choose our solution for better results
          at a fraction of the cost.
        </p>

        <Button
          className="h-11 z-20 bg-primary text-white px-6 py-2 text-medium font-medium plausible-event-name=cta-compare"
          endContent={
            <IconArrowRight
              className="flex-none outline-none [&>path]:stroke-[2]"
              width={20}
              aria-hidden="true"
            />
          }
          radius="full"
          onPress={() => router.push("/seo-ai-pal-vs-competitors")}
          aria-label="See SEO AI Pal vs competitors comparison"
        >
          View comparison
        </Button>
      </div>
    </section>
  );
}
